export default __webpack_public_path__ + "static/media/regreenbus_info_bg.36dbbe63.png";